import { createFileRoute } from '@tanstack/react-router';
import { NotesPage } from '@/features/review/pages';

// «Note» (ADR 0086): every note written in the reviews.
export const Route = createFileRoute('/_app/shipments/notes')({
  component: NotesPage,
});
